var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19198 14.3079C9.57906 14.695 9.57906 15.3226 9.19198 15.7097C8.80489 16.0968 8.17731 16.0968 7.79023 15.7097L5.68761 13.6071C5.30053 13.22 5.30053 12.5924 5.68761 12.2053C6.07469 11.8182 6.70228 11.8182 7.08936 12.2053L9.19198 14.3079ZM7.79025 0.290311C8.17733 -0.0967704 8.80491 -0.0967704 9.19199 0.290311C9.57907 0.677392 9.57907 1.30497 9.19199 1.69206L2.88414 7.99991L4.28589 9.40166C4.67297 9.78874 4.67297 10.4163 4.28589 10.8034C3.8988 11.1905 3.27122 11.1905 2.88414 10.8034L0.781522 8.70078C0.394441 8.3137 0.394441 7.68612 0.781522 7.29904L7.79025 0.290311Z",
    fill: "#1F2D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.d62d15b5eeaf111183984cec2a3658d9.svg";
export { ForwardRef as ReactComponent };